import { getAllCustomers, createDebitor, updateDebitor, deleteDebitor } from './customers/asyncCustomers';
import { getCustomer } from './customer/asyncCustomer';
import { getRMA, putRMA, putARTICLE, patchRMAHistory } from './rma/asyncRma';
import { getAllWarehouse, createWarehouseItem, updateWarehouseItem, deleteWarehouseItem } from './warehouse/asyncWarehouse';
import { getAllRmas, getFilteredRmas, getFilteredArticle, getRmaTracking } from './rmas/asyncRmas';
import { ssoLogin, localLogin, getDataFromSessionID } from './account/asyncAccount';
import { addArticlesRMA, removeArticleRMA } from './article/article';
import { getArticle, postXLSX } from './article/asyncArticle';
import { changeEditMode } from './customer/customer';
import { getFilteredRma, prefetchRmaCounts } from './filteredRma/asyncFilteredRma';
import {
  openModal,
  backStep,
  nextStep,
  addItems,
  resetItems,
  removeItem,
  addDeliverynoteDetails,
  addShipmentData,
  addShipmentDetails,
  resetShipment,
} from './shipmentModal/shipmentModalSlice';
import { postShipment } from './shipmentModal/asyncShipmentModal';
import {
  getDashboardAccepted,
  getDashboardArrived,
  getDashboardTesting,
  getDashboardClarification
} from './dashboard/asyncDashboard';
import { getReport, getReportArticles } from './report/asyncReport';
import { getPaletteItems, searchPaletteItems } from './palette/asyncPalette';

const CUSTOMERS = { getAllCustomers, getCustomer, changeEditMode, createDebitor, updateDebitor, deleteDebitor };
const RMA = {
  getRMA,
  putRMA,
  putARTICLE,
  patchRMAHistory,
  getAllRmas,
  getFilteredRma,
  prefetchRmaCounts,
  getRmaTracking,
  getFilteredRmas,
  getFilteredArticle,
};
const ARTICLE = { getArticle, addArticlesRMA, removeArticleRMA, postXLSX, putARTICLE };
const WAREHOUSE = { getAllWarehouse, createWarehouseItem, updateWarehouseItem, deleteWarehouseItem };
const ACCOUNT = { ssoLogin, localLogin, getDataFromSessionID };
const SHIPMENT_MODAL = {
  openModal,
  nextStep,
  backStep,
  addItems,
  resetItems,
  removeItem,
  addDeliverynoteDetails,
  addShipmentData,
  addShipmentDetails,
  postShipment,
  resetShipment,
};
const DASHBOARD = { getDashboardAccepted, getDashboardArrived, getDashboardTesting, getDashboardClarification };
const REPORT = { getReport, getReportArticles };
const PALETTE = { getPaletteItems, searchPaletteItems };

// --------------------------------------
const actions = {
  ACCOUNT,
  ARTICLE,
  CUSTOMERS,
  RMA,
  WAREHOUSE,
  SHIPMENT_MODAL,
  DASHBOARD,
  REPORT,
  PALETTE,
};

export default actions;
